/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 电影订单列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  movieOrderListReq: order.MovieOrderListReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.IPage<order.EsMovieOrderInfo>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/movie/orders`,
    data: movieOrderListReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
